///Import react section
import React, { Component } from 'react';
import { Translate } from "react-localize-redux";
import autoBind from 'auto-bind';
import { withRouter } from "react-router-dom";
import withauthenticatedLayout from '../layouts/withauthenticatedLayout';
import {loadSampleRequestFromBackEnd} from '../../store/samplerequests/SampleRequestAction'
import { connect } from 'react-redux';
import {cancelWorflowFromBackend} from '../../store/workflows/workflowActions';
import CancelWorkflow from '../common/CancelWorkflow';

class CancelContainer extends Component {
  constructor (props) {
    super(props);
    autoBind(this);
    this.state = {

    }
  }

    /**
    * componentDidMount
    */
   componentDidMount() {
    let quoteToken = this.props.match.params.token;
    this.props.loadSampleRequest(quoteToken);
}

      /**
     * Cancel a corrective actions from back end
     */
    onCancelWorkflowsDocument(cancelComment, razonForCancel){
      let token =this.props.match.params.token;
      this.props.cancelWorflowFromBackend(token, cancelComment, razonForCancel)
      .then(() =>{
        this.props.history.push(`/samplerequests/${this.props.sampleRequest.token}`)
      }).catch(() =>{
          this.setState({
              showToaster: true,
              toasterMessage: <Translate id="common.errorToSave" />,
              toasterVariant: "error",
          })
      })
  }

  render () {
    return (
      <CancelWorkflow
        {...this.props}
          workflow= {this.props.samplerequests}
          onCancelWorkflowsDocument={this.onCancelWorkflowsDocument}
          isSaving={this.props.isCancel}
          link = {'samplerequests'}

      />
    )
  }
}

/**
 *  Defines the properties injecteded from the store to view container
 *
 * @param {*} state
 * @returns
 */
function mapStateToProps(state) {
    let sampleRequest = state.samplerequests.get("sampleRequest");
   return {
      isCancel: state.workflow.get('isCancel'),
      sampleRequest: sampleRequest ? sampleRequest.toJS() : null,
  }
}

/**
 * Defines the actions injectes to the component
 *
 * @param {*} state
 * @returns
 */
const mapDispatchToProps = dispatch => {
  return {
    loadSampleRequest: (token) => {
        return dispatch(loadSampleRequestFromBackEnd(token));
    },
    cancelWorflowFromBackend: (token, cancelComment, razonForCancel) => {
        return dispatch(cancelWorflowFromBackend(token, cancelComment, razonForCancel));
    },
    
  }
}

export default withauthenticatedLayout((withRouter) (connect(mapStateToProps, mapDispatchToProps)(CancelContainer)));